import { observer } from 'mobx-react';
import LicenseExpired from './LicenseExpired';
import Modal from '../../../../../../../../../../../../Modal';
import { T } from '../../../../../../../../../../../../../Translations';

export interface Props {
  close: () => void;
  title: string;
}

function LicenseExpiredModal({ close, title }: Props) {
  return (
    <Modal
      close={close}
      title={
        <h3 className="px-4 py-4 text-xl font-semibold">
          <T kind="Invite to Collection" />
        </h3>
      }
      customBackgroundCssClasses="bg-teal-100 opacity-60"
      modalWidth="w-2/5"
    >
      <LicenseExpired productLicenseTitle={title} />
    </Modal>
  );
}

export default observer(LicenseExpiredModal);
